import type { ReactNode } from 'react'
import { cn } from '@/shared/libs/cn'

interface DataTableFilterFieldProps {
  label: string
  children: ReactNode
  className?: string
}

export function DataTableFilterField({ label, children, className }: DataTableFilterFieldProps) {
  return (
    <div className={cn('flex min-w-[150px] flex-col gap-1.5', className)}>
      <p className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500">{label}</p>
      {children}
    </div>
  )
}
